import { getThemeOptions as getThemeOptionsCommon } from '@lumahealthhq/ui-common';
import { EThemeKey } from '@lumahealthhq/ui-model-types';

// TODO danielmana remove once the latest on ui-common is released and updated
import * as componentsThemeVariant1 from './componentsThemeVariant1';
import * as componentsThemeVariant2 from './componentsThemeVariant2';

export { EThemeKey };

export default function getThemeOptions(themeKey: EThemeKey) {
  const components = themeKey === EThemeKey.Variant2 ? componentsThemeVariant2 : componentsThemeVariant1;

  // @ts-ignore TODO danielmana remove components once the latest on ui-common is released and updated
  return getThemeOptionsCommon(themeKey, { themeKey, components });
}
